import { UserInfo } from "@/models/dossier/user-info";
import { DossierService, MainSocketService } from "@/services";
import { v4 } from "uuid";
import { EventEmitter } from "../event-emitter";
import { IBroadcastFromClientData, IBroadcastToDossierData, IOnClientDisconnectData } from "../services/socket-service-base";
import { tokenStore } from "../token-store";

interface IOpenedClient {
	UserID:number;
	SocketID:string;
	TabID:string;
}

const replyDelay = 250;

export class SaleEditOpenedClientWatcher extends EventEmitter{
	private lastUserList:UserInfo[] = [];

	list:IOpenedClient[] = [];
	saleId:number = 0;
	tabId:string = v4();

	private replyTimeout:number = 0;

	public constructor() {
		super();
		this.beforeWindowUnload = this.beforeWindowUnload.bind(this);
		this.on("list-update", ()=>{
			console.log("Connected users: " + this.getConnectedUsers().map(u=>`${u.ID}/${u.Email}`));
		});
	}

	public setSaleId(id:number){
		if (this.saleId == id) return;
		this.saleId = id;
		this.deInit();
		this.init();
	}

	private init(){
		MainSocketService.on(`/broadcast-from-client/opened-sale/${this.saleId}`, this.onOpened.bind(this), this);
		MainSocketService.on(`/broadcast-from-client/opened-sale-reply/${this.saleId}`, this.onReply.bind(this), this);
		MainSocketService.on(`/broadcast-from-client/opened-sale-close/${this.saleId}`, this.onUserClosed.bind(this), this);
		MainSocketService.on("/ready", this.onSocketReconnected.bind(this), this);
		MainSocketService.on(`/client-disconnected`, this.onDisconnect.bind(this), this);
		window.addEventListener("beforeunload", this.beforeWindowUnload);
		this.request();
	}

	private checkListUpdated(){
		let currentList = this.getConnectedUsers();
		if (this.lastUserList.length != currentList.length) {
			this.lastUserList = currentList;
			this.emit("list-update");
			return;
		}
		for (let user of currentList){
			let index = this.lastUserList.findIndex(f=>f.ID == user.ID);
			if (index != -1) continue;
			this.lastUserList = currentList;
			this.emit("list-update");
			return;
		}
	}

	public deInit(){
		MainSocketService.offAll(this);
		if (this.saleId == 0) return;
		let data:IBroadcastToDossierData = {
			Event: `/opened-sale-close/${this.saleId}`,
			EventID: v4(),
			Payload: this.tabId,
		};
		MainSocketService.emit(`/broadcast-to-dossier`, data);
		window.removeEventListener("beforeunload", this.beforeWindowUnload);
	}

	private onOpened(data:IBroadcastFromClientData){
		if (data.SocketID == tokenStore.socketId) return;
		let foundIndex = this.list.findIndex(f=>f.TabID == data.Payload && f.SocketID == data.SocketID);
		if (foundIndex != -1) return;
		this.list.push({
			SocketID: data.SocketID,
			UserID: data.UserID,
			TabID: data.Payload
		});
		this.checkListUpdated();
		if (this.replyTimeout) return;
		this.replyTimeout = setTimeout(()=>{
			this.replyTimeout = 0;
			this.reply();
		}, replyDelay);
	}

	private beforeWindowUnload(){
		this.deInit();
	}

	private onReply(data:IBroadcastFromClientData){
		if (data.SocketID == tokenStore.socketId) return;
		let foundIndex = this.list.findIndex(f=>f.TabID == data.Payload && f.SocketID == data.SocketID);
		if (foundIndex != -1) return;
		this.list.push({
			SocketID: data.SocketID,
			UserID: data.UserID,
			TabID: data.Payload
		});
		this.checkListUpdated();
	}

	private onDisconnect(data:IOnClientDisconnectData){
		let changes = false;
		for (let i = this.list.length-1; i >= 0; i--){
			if (this.list[i].SocketID == data.SocketID){
				this.list.splice(i,1);
				changes = true;
			}
		}
		if (changes) {
			this.checkListUpdated();
		}
	}

	private onUserClosed(data:IBroadcastFromClientData){
		let changes = false;
		for (let i = this.list.length-1; i >= 0; i--){
			if (this.list[i].SocketID == data.SocketID && this.list[i].TabID == data.Payload){
				this.list.splice(i,1);
				changes = true;
			}
		}
		if (changes) {
			this.checkListUpdated();
		}
	}

	private request(){
		let data:IBroadcastToDossierData = {
			Event: `/opened-sale/${this.saleId}`,
			EventID: v4(),
			Payload: this.tabId
		};
		MainSocketService.emit(`/broadcast-to-dossier`, data);
	}

	private reply(){
		let data:IBroadcastToDossierData = {
			Event: `/opened-sale-reply/${this.saleId}`,
			EventID: v4(),
			Payload: this.tabId
		};
		MainSocketService.emit(`/broadcast-to-dossier`, data);
	}

	private onSocketReconnected(){
		this.list = [];
		this.checkListUpdated();
		this.emit("/list-update");
		this.request();
	}

	public getConnectedUsers():UserInfo[]{
		let result:UserInfo[] = [];
		for (let item of this.list) {
			let i = result.findIndex(u => u.ID == item.UserID);
			if (i!=-1) continue;
			result.push(DossierService.getUser(item.UserID));
		}
		return result;
	}
}